/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Plus, Search, XCircle } from "react-feather";
import { messaging } from "../../services/firebaseConfig";
import { all_routes } from "../../Router/all_routes";
import authService from "../../services/http/auth.service";
import httpService from "../../services/http/settings/country.service";
import { logout } from "../../core/redux/reducers/auth.slice";
import { authSuccess } from "../../core/redux/reducers/auth.slice";
import ReactCountryFlag from "react-country-flag";
import notificationService from "../../services/toaster.service";
import { useTranslation } from "react-i18next";
import { fetchCompanies } from "../../core/redux/reducers/companies.slice";
import LanguageSelector from "../../components/LanguageSelecter";
import useRoleAndPerm from "../../utils/permissionFunction";
import NotificationDropdown from "../../components/notification-dropdown";
import { onMessage } from "firebase/messaging";
import NotificationRequest from "../../services/firebase.service";

const Header = () => {
  const { t, i18n } = useTranslation();
  const { isVendorRole, getRedirectLink } = useRoleAndPerm();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [toggle, SetToggle] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const auth = useSelector((state) => state.auth);
  const user = auth.user;
  const countries = useSelector((state) => state.locations.countries);

  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
    SetToggle((current) => !current);
  };

  const sidebarOverlay = () => {
    document?.querySelector(".main-wrapper")?.classList?.toggle("slide-nav");
    document?.querySelector(".sidebar-overlay")?.classList?.toggle("opened");
    document?.querySelector("html")?.classList?.toggle("menu-opened");
  };

  let pathname = location.pathname;

  const exclusionArray = [
    "/reactjs/template/dream-pos/index-three",
    "/reactjs/template/dream-pos/index-one",
  ];
  if (exclusionArray.indexOf(window.location.pathname) >= 0) {
    return "";
  }

  const handleLogout = async () => {
    navigate("/login");
    const res = await authService.logout();
    localStorage.removeItem("accessToken");
    if (res) dispatch(logout());
  };
  const handleCountryChange = async (record) => {
    setSelectedCountry(null);
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append("id", user.id);
      formData.append("country_id", record.id);
      await httpService.updateCountrySetting(formData).then((response) => {
        if (response.status === 200) {
          const updatedUser = { ...user, country_id: record.id };
          dispatch(
            authSuccess({ accessToken: auth.accessToken, user: updatedUser })
          );
          dispatch(fetchCompanies(true));
          notificationService.successMessage("Country updated successfully!");
          setTimeout(() => {
            navigate(all_routes.dashboard);
          }, 1000);
        }
      });
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (user && countries.length > 0) {
      const userCountry = countries.find(
        (country) => country.id === user.country_id
      );
      setSelectedCountry(userCountry);
    }
  }, [user, countries]);
  const vendorLink = getRedirectLink("company");
  const outletLink = getRedirectLink("outlet");

  NotificationRequest(handleNotificationMessage);
  function handleNotificationMessage(notification) {
    notificationService.notificationInfoMessage(notification);
  }

  return (
    <>
      <div className="header">
        {/* Logo */}
        <div className={`header-left ${toggle ? "" : "active"}`}>
          <Link to="/" className="logo logo-normal">
            <ImageWithBasePath
              src="assets/img/logo.png"
              alt="img"
              height="50px"
            />
          </Link>
          <Link to="/" className="logo logo-white">
            <ImageWithBasePath
              src="assets/img/logo-white.png"
              alt="img"
              height="50px"
            />
          </Link>
          <Link to="/" className="logo-small">
            <ImageWithBasePath
              src="assets/img/logo-small.png"
              alt="img"
              height="30px"
            />
          </Link>
          <Link
            id="toggle_btn"
            to="#"
            style={{
              display: pathname.includes("tasks")
                ? "none"
                : pathname.includes("compose")
                ? "none"
                : "",
            }}
            onClick={handlesidebar}
          >
            <FeatherIcon icon="chevrons-left" className="feather-16" />
          </Link>
        </div>
        {/* /Logo */}
        <Link
          id="mobile_btn"
          className="mobile_btn"
          to="#"
          onClick={sidebarOverlay}
        >
          <span className="bar-icon">
            <span />
            <span />
            <span />
          </span>
        </Link>
        {/* Header Menu */}
        <ul className="nav user-menu">
          {/* Search */}
          <li className="nav-item nav-searchinputs">
            <div className="top-nav-search">
              <Link to="#" className="responsive-search">
                <Search />
              </Link>
            </div>
          </li>
          <NotificationDropdown />

          <LanguageSelector />

          <li className="nav-item dropdown has-arrow main-drop">
            <Link
              to="#"
              className="dropdown-toggle nav-link userset"
              data-bs-toggle="dropdown"
            >
              <span className="user-info">
                <span className="me-2">
                  <ImageWithBasePath
                    type="link"
                    src={user?.image}
                    alt="img"
                    style={{ borderRadius: "50%" }}
                    height="40px"
                    width="40px"
                  />
                </span>
                <span className="user-detail">
                  <span className="user-name">
                    {isVendorRole
                      ? user?.company?.business_name
                      : user?.name ?? "Super Admin"}
                  </span>
                  <span className="user-role">{user?.email ?? ""}</span>
                </span>
              </span>
            </Link>
            <div className="dropdown-menu menu-drop-user">
              <div className="profilename">
                <div className="profileset">
                  {/* <span className="user-img">
                                            <ImageWithBasePath
                                            type="link"
                                            src={user?.image}
                                            alt="img"
                                            className="h-100"
                                            />
                                            <span className="status online" />
                                        </span> */}
                  <div className="profilesets">
                    <h6>{user?.name}</h6>
                    <h5>{user?.email}</h5>
                  </div>
                </div>
                <hr className="m-0" />
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#change-password"
                  className="dropdown-item"
                >
                  {t("general.updatePassword")}
                </Link>
                <Link to={`/user/${user?.id}/edit`} className="dropdown-item">
                  {t("general.myProfile")}
                </Link>
                <hr className="m-0" />
                <div
                  className="dropdown-item logout pb-0"
                  onClick={handleLogout}
                >
                  <ImageWithBasePath
                    src="assets/img/icons/log-out.svg"
                    alt="img"
                    className="me-2"
                  />
                  {t("general.actions.logout")}
                </div>
              </div>
            </div>
          </li>
        </ul>
        {/* /Header Menu */}
        {/* Mobile Menu */}
        <div className="dropdown mobile-user-menu">
          <Link
            to="#"
            className="nav-link dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" />
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            {/* <Link className="dropdown-item" to="profile">
                            My Profile
                            </Link>
                            <Link className="dropdown-item" to="generalsettings">
                            Settings
                            </Link> */}
            <Link className="dropdown-item" to="login">
              Logout
            </Link>
          </div>
        </div>
        {/* /Mobile Menu */}
      </div>
    </>
  );
};

export default Header;
